export default {"src":"/_next/static/media/Vector-quarter-circle.8bb5239a.svg","height":310,"width":210,"blurWidth":0,"blurHeight":0};